export const apiName: string = 'tipos-contas-contabeis';


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/conta-contabil-tipos/shared/data.service.ts
 **/